import React from "react";
import "../scss/header.scss";
import { useState, useEffect } from "react";
import Logo from "../images/vikas.svg";

const Header = () => {
  const [headerBackground, setHeaderBackground] = useState(false);
  const changeBackground = () => {
    if (window.scrollY >= 500) {
      setHeaderBackground(true);
    } else {
      setHeaderBackground(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
  });

  return (
    <header className={headerBackground ? "myHeader active" : "myHeader"}>
      <div className="myHeader_logo">
        <h1>
          <a href="/">
            <img src={Logo} alt="logo" />
          </a>
        </h1>
      </div>
      <nav className="myHeader_nav">
        <ul className="myHeader_nav_links">
          <li className="myHeader_nav_links_link">
            <a href="/#about">About</a>
          </li>
          <li className="myHeader_nav_links_link">
            <a href="/#portfolio">Portfolio</a>
          </li>
          <li className="myHeader_nav_links_link">
            <a href="/#contact">Contact</a>
          </li>
        </ul>
      </nav>
      {/* <Hamburger size={20} toggled={hamburger} /> */}
    </header>
  );
};

export default Header;
